"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDocumentSubjectToString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformDocumentSubjectToString(documentSubject) {
    switch (documentSubject) {
        case legacy_enums_1.DocumentSubject.Driver:
            return "driver";
        case legacy_enums_1.DocumentSubject.Vehicle:
            return "vehicle";
        case legacy_enums_1.DocumentSubject.CompanyDriver:
            return "company driver";
        case legacy_enums_1.DocumentSubject.DriversCompany:
            return "driver's company";
        case legacy_enums_1.DocumentSubject.Soletrader:
            return "mangopay sole trader";
        case legacy_enums_1.DocumentSubject.NaturalPerson:
            return "mangopay natural person";
        case legacy_enums_1.DocumentSubject.LegalPerson:
            return "mangopay legal person";
        default:
            return "unknown";
    }
}
exports.transformDocumentSubjectToString = transformDocumentSubjectToString;
//# sourceMappingURL=transformDocumentSubjectToString.js.map